const SYSTEM_NAME = 'Szlachetna Paczka'
const SYSTEM_SHORTCUT = 'SZP'
const PAYMENT_TITLE = 'Pomagam ze SZLACHETNĄ PACZKĄ'
const SYSTEM_ACCUSATIVE = 'Szlachetną Paczkę'
const SYSTEM_GENITIVE = 'Szlachetnej Paczki'
const LOGO_NAME = 'szp-logo-2023.png'
const EMAIL_ICON_NAME = 'email-white.svg'
const FOOTER_LOGO_NAME = 'logo_short_szp.png'
const SYSTEM_URL_PRIVACY_POLICY = 'https://www.wiosna.org.pl/polityka-prywatnosci/'
const SYSTEM_URL_REGULATIONS = 'https://www.wiosna.org.pl/regulamin-serwisu/'
const SYSTEM_URL_DONATIONS_FROM_ABROAD = 'https://www.szlachetnapaczka.pl/donate/'
const SYSTEM_PAYMENT_LOGO = 'przelewy24_logo_2022_grey.svg'
const SYSTEM_PAYMENT_METHOD = 'Przelewy24'
const SYSTEM_PAYMENT_LOGO_STRIPE = 'stripe-grey.svg'
const SYSTEM_PAYMENT_METHOD_STRIPE = 'Stripe'
const SYSTEM_SAFE_PAYMENT_ICON = 'safe-payment-icon-grey.svg'
const SYSTEM_SAFE_PAYMENT_TEXT = 'Bezpieczne płatności'
const SYSTEM_FACEBOOK_URL = 'http://facebook.pl/szlachetna-paczka'
const SYSTEM_INSTAGRAM_URL = 'https://www.instagram.com/szlachetnapaczka/'
const SYSTEM_YOUTUBE_URL = 'https://www.youtube.com/channel/UCvGAB68zmhmXWGUo-nhmbZg'
const SUMMARY_LOGO_NAME = 'szp-logo-2022.png'
const SUMMARY_FOOTER_EMAIL = 'dobroczynca@wiosna.org.pl'
const THANK_YOU_TEXT_FIRST = 'za Twoją wpłatę i zaangażowanie w&nbsp;pomaganie<br>ze Szlachetną Paczką. '
const THANK_YOU_TEXT_SECOND = 'Dzięki Tobie świat staje się piękniejszy.'
const FB_SHARE_LINK = 'https://www.facebook.com/sharer/sharer.php?u=http%3A//szlachetnapaczka.pl/'
const KEY1_SKU = 5
const KEY2_SKU = 2
const KEY3_SKU = 3
const KEY4_SKU = 4
const KEY5_SKU = 6
const SHOW_BLIK_HINT = true

export default {
    SYSTEM_NAME: SYSTEM_NAME,
    SYSTEM_SHORTCUT: SYSTEM_SHORTCUT,
    PAYMENT_TITLE: PAYMENT_TITLE,
    SYSTEM_ACCUSATIVE: SYSTEM_ACCUSATIVE,
    SYSTEM_GENITIVE: SYSTEM_GENITIVE,
    LOGO_NAME: LOGO_NAME,
    SYSTEM_URL_PRIVACY_POLICY: SYSTEM_URL_PRIVACY_POLICY,
    SYSTEM_URL_DONATIONS_FROM_ABROAD: SYSTEM_URL_DONATIONS_FROM_ABROAD,
    SYSTEM_URL_REGULATIONS: SYSTEM_URL_REGULATIONS,
    EMAIL_ICON_NAME: EMAIL_ICON_NAME,
    FOOTER_LOGO_NAME: FOOTER_LOGO_NAME,
    SYSTEM_PAYMENT_LOGO: SYSTEM_PAYMENT_LOGO,
    SYSTEM_PAYMENT_METHOD: SYSTEM_PAYMENT_METHOD,
    SYSTEM_PAYMENT_LOGO_STRIPE: SYSTEM_PAYMENT_LOGO_STRIPE,
    SYSTEM_PAYMENT_METHOD_STRIPE: SYSTEM_PAYMENT_METHOD_STRIPE,
    SYSTEM_SAFE_PAYMENT_ICON: SYSTEM_SAFE_PAYMENT_ICON,
    SYSTEM_SAFE_PAYMENT_TEXT: SYSTEM_SAFE_PAYMENT_TEXT,
    SYSTEM_FACEBOOK_URL: SYSTEM_FACEBOOK_URL,
    SYSTEM_INSTAGRAM_URL: SYSTEM_INSTAGRAM_URL,
    SYSTEM_YOUTUBE_URL: SYSTEM_YOUTUBE_URL,
    SUMMARY_LOGO_NAME: SUMMARY_LOGO_NAME,
    SUMMARY_FOOTER_EMAIL: SUMMARY_FOOTER_EMAIL,
    THANK_YOU_TEXT_FIRST: THANK_YOU_TEXT_FIRST,
    THANK_YOU_TEXT_SECOND: THANK_YOU_TEXT_SECOND,
    FB_SHARE_LINK: FB_SHARE_LINK,
    KEY1_SKU: KEY1_SKU,
    KEY2_SKU: KEY2_SKU,
    KEY3_SKU: KEY3_SKU,
    KEY4_SKU: KEY4_SKU,
    KEY5_SKU: KEY5_SKU,
    SHOW_BLIK_HINT: SHOW_BLIK_HINT
}
